export default __webpack_public_path__ + "static/sportreizen_icons-798a3d689fc1bd8a0caa63eee4694b81.svg";